<template lang="pug">
  self-image(v-if="$route.params.type === `image`")
  self-video(v-else-if="$route.params.type === `video`")
  self-kodon(v-else-if="$route.params.type === `ko-don`")
</template>

<script>
import SelfImage from './image/'
import SelfKodon from './ko-don/'
import SelfVideo from './video/'

const route = {
  name: `AddSetup`,
  path: `/add-setup/:type`
}

export default {
  ...route,

  components: {
    SelfImage,
    SelfKodon,
    SelfVideo
  }
}
</script>